import React from 'react'
import { Button, FormControl, Grid, TextField } from '@mui/material'

export const ModalFormExpenses = ({useFetchInit}) => {

    const {
        globalStates,
        Forms,
        Actions
    } = useFetchInit

    const { FormExpenses } = Forms
    const { formState, onInputChange, onInputNumberChange } = FormExpenses

    const {
        handleClickCloseModal,
        onSubmitFormExpenses
    } = Actions

    const { modalOpeningMode } = globalStates

    return (
        <form onSubmit={onSubmitFormExpenses}>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth> 
                        <label htmlFor="info_fecha_pago">* Fecha del cargo</label>
                        <TextField
                            id='info_fecha_pago'
                            name='info_fecha_pago'
                            value={ formState.info_fecha_pago }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Fecha'
                            hiddenLabel
                            type='date'
                            variant={ 'outlined' }
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth> 
                        <label htmlFor="info_costo">* Monto en Quetzales</label>
                        <TextField
                            id='info_costo'
                            name='info_costo'
                            value={ formState.info_costo_mask }
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='Monto del cargo'
                            hiddenLabel
                            type='text'
                            variant={ 'outlined' }
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth> 
                        <label htmlFor="info_descripcion">Descripcion del cargo</label>
                        <TextField
                            id='info_descripcion'
                            name='info_descripcion'
                            value={ formState.info_descripcion }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Monto del cargo'
                            hiddenLabel
                            multiline
                            rows={5}
                            type='text'
                            variant={ 'outlined' }
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <div className="border-bottom border-secondary "></div>

            <div className="pt-4"></div>
            <Grid container>
                <Grid item>
                    <div className='update ml-auto mr-auto'>
                        <Button
                            style={{ background: "#4b4b4c" }}
                            variant="contained"
                            type="submit"
                        >
                           <i className="fa-regular fa-floppy-disk"></i> &nbsp;  Guardar
                        </Button>
                        &nbsp; &nbsp;
                        <Button 
                            style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                            variant="contained"
                            type="button" 
                            onClick={() => handleClickCloseModal(false, 'EDIT')} 
                        >
                            <i className="fa-regular fa-circle-left"></i> &nbsp; Volver
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </form>
    )
}
